import {BasicEntity, BasicProperty} from "../../basic-entity-back/annotations";
import {PropertyType} from "../../basic-entity-back/property-type/property-type";
import {PropertyMap, ReadWrite} from "../../basic-entity-back/basic-entity-interface/mapping-external";
import {Archivo} from "./archivo.model";

@BasicEntity({
    name: 'Archivo',
    endpoint: 'archivo_s_t_l_solicituds',
    isPaginated: true,
    paginationSizes: [20, 30, 50],
    type: "ArchivoSTLSolicitud",
    modelNameProperty: 'nombreFichero'
})
export class ArchivoSTLSolicitud extends Archivo {
    public static readonly SOLICITUD_MAP: PropertyMap = {
        name: 'Diseño Solicitud',
        type: PropertyType.FutureUri('diseno-solicitud.model.ts'),
        readWrite: ReadWrite.ReadOnly
    }
    @BasicProperty(ArchivoSTLSolicitud.SOLICITUD_MAP)
    private _disenoSolicitud;

    get disenoSolicitud() {
        return this._disenoSolicitud;
    }

    set disenoSolicitud(value) {
        this._disenoSolicitud = value;
    }
}
